import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.jpg'


const _withScopeId = n => (_pushScopeId("data-v-05189299"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-red-pack" }
const _hoisted_2 = { class: "create-container" }
const _hoisted_3 = {
  key: 0,
  class: "create-main"
}
const _hoisted_4 = {
  key: 0,
  class: "create-form"
}
const _hoisted_5 = { class: "form-label-container" }
const _hoisted_6 = { class: "form-label" }
const _hoisted_7 = { class: "form-input" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "form-input-amount" }, "piece", -1))
const _hoisted_9 = { class: "form-label-container" }
const _hoisted_10 = { class: "form-input-flex" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "form-label-container form-label-container-balance" }
const _hoisted_13 = { class: "form-label" }
const _hoisted_14 = {
  key: 1,
  class: "total-quantity-loading"
}
const _hoisted_15 = { class: "create-handle" }
const _hoisted_16 = {
  key: 0,
  class: "create-button"
}
const _hoisted_17 = {
  key: 0,
  class: "allow-loading"
}
const _hoisted_18 = {
  key: 0,
  class: "create-handle-button"
}
const _hoisted_19 = {
  key: 1,
  class: "create-handle-button"
}
const _hoisted_20 = {
  key: 1,
  class: "create-handle-button create-handle-sold-out"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Concluded", -1))
const _hoisted_22 = {
  key: 1,
  class: "create-ps"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Connect your wallet to proceed", -1))
const _hoisted_24 = { class: "connect-info" }
const _hoisted_25 = {
  key: 1,
  class: "connect-error-msg"
}
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<div class=\"create-ps\" data-v-05189299><div class=\"polic\" data-v-05189299><img src=\"" + _imports_0 + "\" alt=\"\" data-v-05189299></div><h2 data-v-05189299>About Hope for Children NFT</h2><p data-v-05189299>Hope for Children NFT is a limited Non-Fungible Token served as the proof of donation issued by <a class=\"ps-link\" href=\"https://www.uncrcpc.org/about-us/\" target=\"_blank\" rel=\"noopener noreferrer\" data-v-05189299>“Hope For Children” CRC Policy Center</a>, an International Humanitarian and Independent Institution based in Nicosia, Cyprus, Function X Foundation and Pundi X. This is a mint-to-donate NFT. Participants will be able to donate PURSE tokens through minting the limited version of Hope for Children NFT. A total of 50,000 Hope For Children NFTs will be available for participants to mint with 100 different designs.</p><br data-v-05189299><p data-v-05189299>This series of NFTs features the children of all nations holding signage to display their desire, including peace, no wars, love, courage, trust and more. All the PURSE tokens used to mint the NFT will be donated to the Hope for Children Ukraine task force to specifically improve the welfare of the children suffering from the war in Ukraine.</p></div><div class=\"create-ps not-center\" data-v-05189299><h4 data-v-05189299>How to get one</h4><p data-v-05189299><span data-v-05189299>1. </span>Each piece requires 20,000 PURSE BEP20 to mint. Users can mint up to 10 pieces in one transaction.</p><p data-v-05189299><span data-v-05189299>2. </span>The NFT collection is on a first-come-first-get basis.</p><p data-v-05189299><span data-v-05189299>3. </span>The design of the NFT cannot be pre-selected. It will be unlocked after successfully minted.</p><br data-v-05189299><h4 data-v-05189299>Note: </h4><p data-v-05189299>BNB BEP20 is required for transaction fees and PURSE transaction adopts <a class=\"ps-link\" href=\"https://miro.medium.com/max/1400/1*XkZvy0JabYYzwIocd-OWQg.png\" target=\"_blank\" rel=\"noopener noreferrer\" data-v-05189299>BDL model</a>.</p></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_greeting_card = _resolveComponent("greeting-card")!
  const _component_fx_input = _resolveComponent("fx-input")!
  const _component_loading = _resolveComponent("loading")!
  const _component_personality_button = _resolveComponent("personality-button")!
  const _component_wallet_list = _resolveComponent("wallet-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_greeting_card, {
        img: require('@/assets/images/missionwagmiIcon/web_random.jpg'),
        greetings: _ctx.redPackData.title
      }, null, 8, ["img", "greetings"]),
      (_ctx.userInfo.address)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.totalQuantityReady)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (Number(_ctx.totalQuantityVal) >= 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.$checkI18n("create.amount")), 1),
                            _createElementVNode("p", null, "Remaining: " + _toDisplayString(_ctx.totalQuantityVal), 1)
                          ]),
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_fx_input, {
                              modelValue: _ctx.redPackData.number,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.redPackData.number) = $event)),
                              align: "left",
                              onInput: _ctx.redPackNumberBlur
                            }, {
                              append: _withCtx(() => [
                                _hoisted_8
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onInput"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pieceList, (p, index) => {
                              return (_openBlock(), _createElementBlock("p", {
                                class: _normalizeClass(['form-input-button', { active: _ctx.pieceActive == p.value

                }]),
                                onClick: ($event: any) => (_ctx.setPiece(p.value)),
                                key: index
                              }, _toDisplayString(p.text), 11, _hoisted_11))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.$checkI18n("create.balance")), 1)
                          ]),
                          _createElementVNode("h5", null, _toDisplayString(_ctx.$tools.getShowNumByNum(_ctx.$tools.amountDivDecimal(_ctx.userInfo.balance, _ctx.tokenInfo.decimals))) + " " + _toDisplayString(_ctx.tokenInfo.symbol), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_component_loading)
                ]))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_15, [
      (_ctx.userInfo.address)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.totalQuantityReady)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (Number(_ctx.totalQuantityVal) >= 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        (_ctx.tokenInfo.contract && _ctx.loading.allowance)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _createVNode(_component_loading, { iconName: "common-icon-loadingH" })
                            ]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (_ctx.stepStatus && !_ctx.sendStatus)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    _createVNode(_component_personality_button, {
                                      type: "form",
                                      loading: _ctx.loading.approve,
                                      onClick: _ctx.approve
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("h4", null, _toDisplayString(_ctx.$checkI18n("create.approve")), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["loading", "onClick"])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _createVNode(_component_personality_button, {
                                      type: "form",
                                      loading: _ctx.sendLoading,
                                      disabled: _ctx.sendStatus,
                                      onClick: _ctx.nftBuy,
                                      colorText: _ctx.colorText
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("h4", null, _toDisplayString(_ctx.textSendButton), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["loading", "disabled", "onClick", "colorText"])
                                  ]))
                            ], 64))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createVNode(_component_personality_button, {
                          type: "form",
                          colorText: 'warn',
                          disabled: _ctx.sendStatus
                        }, {
                          default: _withCtx(() => [
                            _hoisted_21
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]))
                ], 64))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              (!_ctx.connectErrorMsg)
                ? (_openBlock(), _createBlock(_component_wallet_list, {
                    key: 0,
                    onConnect: _ctx.connectHandler,
                    onConnectError: _ctx.connectErrorHandler
                  }, null, 8, ["onConnect", "onConnectError"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("h4", null, _toDisplayString(_ctx.connectErrorMsg), 1)
                  ]))
            ])
          ])),
      _hoisted_26
    ])
  ]))
}